import React from "react"
import { isEqual } from "lodash"
import { Button } from "antd"
import PropTypes from "prop-types"
import {
  ROLE_MANDU_ADMIN,
  ROLE_MANDU_SUPER_ADMIN,
} from "../../../../utils/constants"

class UserManduFooter extends React.Component {
  submit = () => {
    const { currentData } = this.props
    const { validateFieldsAndScroll } = this.props.form
    validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.pressSave(currentData)
      }
    })
  }

  validateUserCompaniesAccess = () => {
    const { companiesUserAccesses, id_role } = this.props.currentData
    const { isNew } = this.props
    const checkUndefinedCompanies = companiesUserAccesses != null
    const checkUndefinedIdRole = id_role != null

    const checkIfAdministrator = checkUndefinedIdRole
      ? id_role === ROLE_MANDU_ADMIN
      : false

    const checkPermissionActive =
      checkUndefinedCompanies || checkIfAdministrator

    let checkIfActive =
      checkPermissionActive && checkUndefinedCompanies
        ? companiesUserAccesses.length > 0
        : false

    checkIfActive =
      checkPermissionActive === false && checkUndefinedCompanies === false
        ? true
        : checkIfActive

    return isNew === false ? true : checkIfActive
  }

  validateTab = (props) => {
    if (
      props.isNew === false &&
      props.tab === "1" &&
      props.currentData.id_role !== ROLE_MANDU_SUPER_ADMIN
    ) {
      return false
    }
    return true
  }

  checkIfIsNewUserAndReturnWithoutCompanyHasUser = ({
    isNew,
    currentDataBackup,
    currentData,
  }) => {
    if (!isNew) {
      const currentDataNew = JSON.parse(JSON.stringify(currentData))
      const currentDataBackupNew = JSON.parse(JSON.stringify(currentDataBackup))

      delete currentDataNew.companies_access
      delete currentDataNew.companiesUserAccesses
      delete currentDataBackupNew.companies_access
      delete currentDataBackupNew.companiesUserAccesses
      return {
        currentData: currentDataNew,
        currentDataBackup: currentDataBackupNew,
      }
    }
    return { currentData, currentDataBackup }
  }

  render() {
    const { isNew, save_loading } = this.props
    const hasFreshchat =typeof window.Intercom !== "undefined" &&
    window.self === window.top;
    const {
      currentData,
      currentDataBackup,
    } = this.checkIfIsNewUserAndReturnWithoutCompanyHasUser(this.props)
    return (
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: hasFreshchat ? 'calc(100% - 88px)' : '100%',
          borderTop: "1px solid #e8e8e8",
          textAlign: "right",
          left: 0,
          background: "#fff",
          borderRadius: "0 0 4px 4px",
          paddingTop: "16px",
          paddingBottom: "16px",
          paddingLeft: "16px",
          paddingRight: hasFreshchat ? "0px!important" : "16px",
          display:
            (isNew || !isEqual(currentDataBackup, currentData)) &&
            this.validateTab(this.props)
              ? ""
              : "none",
        }}>
        <Button
          disabled={save_loading}
          style={{ marginRight: 8 }}
          onClick={() => {
            this.props.form.resetFields()
            this.props.hide()
          }}>
          Cancelar
        </Button>
        <Button
          loading={save_loading}
          disabled={
            !currentData.email ||
            !currentData.id_role ||
            !currentData.first_name ||
            !currentData.last_name ||
            !this.validateUserCompaniesAccess()
          }
          onClick={(e) => this.submit(e)}
          type="primary">
          {isNew ? "Crear" : "Guardar"}
        </Button>
      </div>
    )
  }
}

UserManduFooter.propTypes = {
  save_loading: PropTypes.bool,
  isNew: PropTypes.bool,
  currentData: PropTypes.object,
  currentDataBackup: PropTypes.object,
  hide: PropTypes.func,
  validateFieldsAndScroll: PropTypes.func,
  pressSave: PropTypes.func,
  form: PropTypes.object,
}

export default UserManduFooter
